import type { RouteRecordRaw, Router } from "vue-router";

const dynamicRouteNames = new Set<string>();

function getRouteName(route: RouteRecordRaw) {
  return typeof route.name === "string" ? route.name : undefined;
}

export function addDynamicRoutes(router: Router, routes: RouteRecordRaw[]) {
  routes.forEach((route) => {
    const name = getRouteName(route);

    if (name && !router.hasRoute(name)) {
      router.addRoute(route);
      dynamicRouteNames.add(name);
    }
  });
}

export function removeDynamicRoutes(router: Router) {
  dynamicRouteNames.forEach((name) => {
    if (router.hasRoute(name)) {
      router.removeRoute(name);
    }
  });

  dynamicRouteNames.clear();
}
